module.exports = __webpack_public_path__ + "static/img/11.e43c647.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/zh/11.png
// module id = QX+V
// module chunks = 0